module.exports = __webpack_public_path__ + "img/v4_expetionLog.88cec3e1.png";